import Category from 'actions/category';

export default Category.createReducer();